import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Guards a region of the DOM and triggers events when widgets
 * are added and removed from the container.
 */
export default class ContainerWidget extends Widget {
	constructor() {
		super(...arguments);

		this._widgets = [];
	}

	set(newWidgets) {
		if (!Array.isArray(newWidgets)) {
			newWidgets = [newWidgets];
		}

		this.empty();
		this._widgets = newWidgets;

		this._widgets.forEach((aWidget) => {
			this.trigger("added", aWidget);
		});

		this.update();
	}

	empty() {
		this._widgets.forEach((aWidget) => {
			this.trigger("removed", aWidget);
		});

		this._widgets = [];
		this.update();
	}

	renderContentOn(html) {
		html.render(this._widgets);
	}
}
